<template>
  <div class="mx-auto pa-5 w-75">
    <h1 class="text-white">
      2024年12月19日発売！！
    </h1>
    <div class="text-center my-10">
      <v-btn
        variant="outlined"
        href="http://d-mebius.com/apathyboy/stream.html"
        color="primary"
        target="_blank"
        align="center"
        width="480"
        height="80"
      >
        <p class="text-h5">実況・動画配信ガイドライン</p>
      </v-btn>
    </div>
  </div>

  <!-- <SubTitle :TitleName="'PV'" />
  <Movie /> -->
</template>

<script>
  //import SS from "./ScreenShot.vue";
  //import SubTitle from "./SubTitle.vue";
  //import Movie from "./YouTube.vue";

  // export default {
  //   name: "App",
  //   components: {
  // SS,
  //SubTitle,
  // Movie,
  //   },
  // };
</script>
